import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Backdrop, CircularProgress,Box } from "@mui/material";
import Breadcrumb from "../../components/Breadcrumb";
import Stepper from "./Stepper";
import PersonalInfoStep from "./steps/PersonalInfoStep";
import AddressStep from "./steps/AddressStep";
import BaptismsStep from "./steps/BaptismsStep";
import MarriageStep from "./steps/MarriageStep";
import ImageUploadStep from './steps/ImageUploadStep';
import TestimonyStep from './steps/TestimonyStep';
import ContactSearchPage from "./contactSearch/ContactSearchPage"
import { CreateContact, GetContact, UpdateContact,  } from "../../service/odoo";
import { GetItem } from "utils/storage";
import { DefaultSwrOptions, StorageKey } from "../../constants/constants";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);



const initialValues = {
    first_name: "",
    middle_name: "",
    last_name: "",
    gender: "",
    birthdate_date: "",
    phone: "",
    mobile: "",
    email: "",
    nationality: "",
    marital_status: "",
    occupation: "",
    address: {
        street: "",
        interior_number: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country_id: "",
        partner_latitude: "",
        partner_longitude: "",
        place_id: "",
        full_address: "",
        url: "",
        reference: "",
    },
    church_id: 0,
    groups: [],
    testimonial: "",
    birth_state_id: "",
    image_base64: "",
    image_url: "",
    form_type: "",
    bautismos: {
        bautismo_aguas: {
            enabled: false,
            fecha: "",
            pastor_id: 0,
            pastor_name: "",
            church_id: 0,
        },
        bautismo_espiritu_santo: {
            enabled: false,
            fecha: "",
            pastor_id: 0,
            pastor_name: "",
            church_id: 0,
        },
    },
    matrimonio: {
    
        conyugue: {
            conyugue_id: 0,
            conyugue_first_name: "",
            conyugue_middle_name: "",
            conyugue_last_name: "",
        },
        pastor_name: "",
        pastor_id: 0,
        church_id: 0,
        marital_status: "",
    },
};

  const makeConditionalRequired = (enabled, message) => (enabled, schema) => {
    if (enabled[0] === true) {
      return schema.required(message);
    }
    return schema.nullable();
  };


const validationSchema = [
    Yup.object({
        first_name: Yup.string().required("Nombre requerido"),
        middle_name: Yup.string().required("Apellido Paterno requerido"),
        last_name: Yup.string().required("Apellido Materno requerido"),
        gender: Yup.string().required("Género requerido"),
        birthdate_date: Yup.date()
        .required("Fecha de nacimiento requerida")
        .max(new Date(new Date().setDate(new Date().getDate() - 1)), "Proporcione una fecha válida"),
       mobile: Yup.string()
        /*.matches(/^\d{10,}$/, "El número celular debe tener al menos 10 dígitos")*/
        .required("Número Celular requerido"),
       
    }),
    Yup.object({
      marital_status: Yup.string().required("Estado Civil es requerido"),
      /*
      
    address: Yup.object({
      street: Yup.string().required("Calle requerida"),
      city: Yup.string().required("Ciudad requerida"),
      state: Yup.string().required("Estado requerido"),
      zip: Yup.number().required("Código postal requerido"),
    }),*/
    }),


    Yup.object({
      bautismos: Yup.object().shape({
        bautismo_aguas: Yup.object().shape({
          enabled: Yup.boolean(),
          fecha: Yup.string().when("enabled", makeConditionalRequired("La fecha es obligatoria")),
          pastor_id: Yup.number().when("enabled", makeConditionalRequired("El pastor que bautizó es obligatorio")),
          church_id: Yup.number().when("enabled", makeConditionalRequired("La iglesia es obligatoria")),
        }),
        bautismo_espiritu_santo: Yup.object().shape({
          enabled: Yup.boolean(),
          fecha: Yup.string().when("enabled", makeConditionalRequired("La fecha es obligatoria")),
          pastor_id: Yup.number().when("enabled", makeConditionalRequired("El pastor es obligatorio")),
          church_id: Yup.number().when("enabled", makeConditionalRequired("El ID de la iglesia es obligatorio")),
        }),
      }),
    })
];


const ContactFormStepper = () => {

    const [metadata, setMetadata] = useState({
        pastors: [],
        churches: [],
        states: [],
        marital_status: [],
        groups: [],
        form_type: ""
    });
    const [contactSelected, setContactSelected] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const fetchMetadata = async () => {
            try {
                const user = await GetItem(StorageKey.USER);
                const storedFormType = await GetItem("form_type"); 
                console.log(storedFormType)
                setMetadata({
                    pastors: user?.metadata?.pastors || [],
                    churches: user?.metadata?.churches || [],
                    states: user?.metadata?.states || [],
                    marital_status: user?.metadata?.marital_status || [],
                    groups: user?.metadata?.groups || [],
                    form_type: storedFormType || user?.metadata?.form_type || ''
                });
            } catch (error) {
                console.error("Error cargando metadata:", error);
            }
        };
        fetchMetadata();
    }, []);

    const handleSelectContact = (contact) => {
        console.log(contact)
        setContactSelected({
            ...contact,
            form_type: metadata.form_type // Priorizar form_type
          });
    };

    const handleNext = () => {

        
        setCurrentStep((prev) => prev + 1); // Avanzar al siguiente paso
    };

    const handlePrevious = () => {
        setCurrentStep((prev) => prev - 1); // Retroceder al paso anterior
    };

    const markAllTouched = (values) => {
        const touchedFields = {};
        Object.keys(values).forEach((key) => {
          if (typeof values[key] === "object" && values[key] !== null) {
            touchedFields[key] = markAllTouched(values[key]); // Recursivo para objetos anidados
          } else {
            touchedFields[key] = true;
          }
        });
        return touchedFields;
      };

      const dynamicInitialValues = {
        ...initialValues,
        form_type: metadata.form_type || initialValues.form_type,
      };

      const resetFormToInitial = () => {
        setContactSelected(null);
        setCurrentStep(0);
      };
      const handleSubmit = async (values) => {
        setLoading(true);
        try {
          if (contactSelected?.id) {
            // Actualizar contacto existente
            const res = await UpdateContact(values, contactSelected.id);
            if (res.status === 200) {
              MySwal.fire({
                title: "¡Registro exitoso!",
                text: "El contacto ha sido actualizado exitosamente.",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
              resetFormToInitial(); // Reiniciar el formulario y regresar al inicio
            } else {
              throw new Error("Error al actualizar el contacto");
            }
          } else {
            // Crear nuevo contacto
            const res = await CreateContact(values);
            if (res.status === 200) {
              MySwal.fire({
                title: "¡Registro exitoso!",
                text: "El contacto ha sido creado exitosamente.",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
              resetFormToInitial(); // Reiniciar el formulario y regresar al inicio
            } else {
              throw new Error("Error al crear el contacto");
            }
          }
        } catch (error) {
          MySwal.fire({
            title: "Error",
            text: "Ocurrió un problema al guardar el registro. Intenta nuevamente.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          console.error("Error al guardar:", error);
        } finally {
          setLoading(false); // Ocultar indicador de carga
        }
      };

    return (
      <>
        <ToastContainer />
        <Backdrop open={loading} style={{ color: "#fff", zIndex: 1300 }}>
            <CircularProgress color="inherit" />
        </Backdrop>

        {!contactSelected ? (
          <ContactSearchPage onSelectContact={handleSelectContact} />
        ) : (
            <>
            <Breadcrumb
                title={`Registro de ${metadata.form_type}`}
                items={[
                    { to: '/app', title: 'Inicio' },
                    { title: metadata.form_type },
                ]}
            />
            <Box sx={{ width: '100%' }}>
          <Formik
            key={contactSelected?.id || "nuevo-contacto"}
            initialValues={contactSelected.id ? contactSelected : dynamicInitialValues}
            validationSchema={validationSchema[currentStep]}
            validateOnChange
            validateOnBlur
            enableReinitialize
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, validateForm, setTouched }) => (
              <Form>
                <Stepper
                  steps={[
                    { component: PersonalInfoStep, label: "Información Personal" },
                    { component: MarriageStep, label: "Vida Sentimental" },
                    { component: ImageUploadStep, label: "Subir Foto" },
                    { component: AddressStep, label: "Dirección" },
                    { component: BaptismsStep, label: "Datos de Bautismo" },
                    { component: TestimonyStep, label: "Testimonio" }
                  ]}
                  currentStep={currentStep}
                  onNext={() => {
                    setTouched(markAllTouched(values)); // Marcar todos los campos como touched
                    validateForm().then((validationErrors) => {
                      console.log("+++++++++++++errores+++++++++++++++")
                      console.log(validationErrors)
                      if (Object.keys(validationErrors).length === 0) {
                        handleNext(); // Avanzar si no hay errores
                      } else {
                        toast.error(
                          "Por favor corrige los errores antes de continuar",
                          { position: "top-right", autoClose: 3000 }
                        );
                      }
                    });
                  }}
                  onPrevious={handlePrevious}
                  showProgressBar
                  highlightErrorStep
                  formValues={values}
                  formErrors={errors}
                  formTouched={touched}
                  metadata={metadata}
                  onSubmit={() => {
                    setTouched(markAllTouched(values)); // Marcar todos los campos como touched
                    validateForm().then((validationErrors) => {
                      if (Object.keys(validationErrors).length === 0) {
                        handleSubmit(values); // Solo enviar si no hay errores
                      } else {
                        toast.error("Por favor corrige los errores antes de enviar", {
                          position: "top-right",
                          autoClose: 3000,
                        });
                      }
                    });
                  }}
                />
              </Form>
            )}
          </Formik>
          </Box>
          </>
        )}
      </>
    );
  };
export default ContactFormStepper;
